// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type FastTimer40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const FastTimer40: FC<FastTimer40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M25 33.333c-3.722 0-6.875-1.291-9.458-3.875-2.584-2.583-3.875-5.736-3.875-9.458 0-3.713 1.291-6.863 3.875-9.451C18.125 7.96 21.278 6.667 25 6.667c3.713 0 6.863 1.294 9.451 3.882s3.882 5.738 3.882 9.451c0 3.722-1.294 6.875-3.882 9.458-2.588 2.584-5.738 3.875-9.451 3.875Zm-.006-2.777c2.93 0 5.423-1.026 7.478-3.077 2.056-2.051 3.084-4.542 3.084-7.472 0-2.93-1.026-5.424-3.077-7.48-2.052-2.055-4.542-3.083-7.473-3.083-2.93 0-5.423 1.026-7.478 3.077-2.056 2.051-3.084 4.542-3.084 7.473 0 2.93 1.026 5.423 3.077 7.478 2.051 2.056 4.542 3.084 7.473 3.084Zm4.103-4.514 1.958-1.959-4.666-4.666v-6.084H23.61v7.237l5.486 5.472ZM3.333 14.722v-2.777H10v2.777H3.333ZM1.667 21.39V18.61H10v2.778H1.667Zm1.666 6.667v-2.778H10v2.778H3.333Z" />
        </svg>
    );
};

export default FastTimer40;
